import React, {useEffect, useState} from 'react';
import {getCustomerCart, checkoutCart, updateCart, getResourceFile, getCatalogue} from '../../network';
import {formatPrice} from '../../helpers/Helper';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {setCart} from '../../redux/actions/CartActions';
import ConfirmationComponent from '../shared/ConfirmationComponent';
import LoadingComponent from '../shared/LoadingComponent';
import CustomCheckbox from '../shared/CheckboxComponent';
import useComponentVisible from '../../hooks/useComponentVisible';
import ProductItem from '../ProductItem';

const Layout = styled.div`
    display: flex;
    justify-content: center;
    /* grid-template-columns: 35rem auto;
    grid-template-rows: auto; */
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: 5rem;
    margin-bottom: 6rem;

    > .mobile-subtotal{
        display: none;
    }
    
    > .title {
        margin-bottom: var(--space-56);
        
        font-size: var(--font-40);
        line-height: var(--font-40);
        font-weight: 500;
      
        color: var(--company-dark);
    }
    @media (max-width: 500px){
        /* grid-template-columns: auto;
        grid-template-rows: 1fr auto; */

        > .mobile-subtotal{
        display: flex;
        flex-direction: row;
        
        align-items: center;
        
        /* align-self: flex-end; */
        
        margin-bottom: var(--space-28);
    
        > .title {
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-16);
            line-height: var(--font-16);
        
            margin-right: var(--space-8);
            color: var(--color-neutral-gray-900);
        }
    
        > .price {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-16);
            line-height: var(--font-16);
        
            color: var(--color-blue-600);
        }
    }
    }
    @media (max-width: 500px){
        .title{
            font-size: var(--font-32);
        }
        .order{
            padding-left: 0rem;
            font-size: var(--font-24);
        }
     
       
    }
`;

const ImageContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    width: 8.5rem;
    //height: 0;
    grid-gap: 1rem;
    grid-template-rows: auto 2.5rem;
    margin-right: var(--space-32);
    
    > .image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      width: 100%;
      height: 8.25rem;
  
      background: white;
  
      //margin-bottom: var(--space-40);
  
      border: 1px solid var(--color-gray-300);
      box-sizing: border-box;
      border-radius: 0.5rem;
      
      > img {
        width: 90%;
        height: 90%;
        object-fit: contain;
        padding: 0.25rem;
      }
    }

    @media (max-width: 500px){
       margin-right: 0rem;
        .image-container{
            width: 70%;
            height: 5.25rem;

            > img{
                width: 70%;
                height: 70%;
            }
        }
    }
`;

const OrderDetailsContainer = styled.div`
    /* display: grid;
    grid-auto-flow: row; */

`;

const SummaryContainer = styled.div`
    position: relative;
    display: grid;
    grid-auto-flow: row;
    width: 23.5rem;
    height: 19.5rem;
    
    padding: var(--space-32) var(--space-24) var(--space-28) var(--space-24);
    
    background: white;

    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-16);
    
    div {
        &:nth-of-type(2) {
            margin-top: var(--space-32);
            margin-bottom: var(--space-24);
        }
        
        &:nth-of-type(3), &:nth-of-type(4) {
            margin-bottom: var(--space-24);
        }
        
        &:nth-of-type(6) {
            margin-top: var(--space-40);
        }
    }

    @media (max-width: 800px){
        margin-top: 5rem;
        width: auto;
    }
    @media (max-width: 500px){
        padding: 0rem;
        border: none;

        .divider{
            width: auto;
            height: 0px;
            margin-top: 2rem;
            border: 1px solid #B3BDC6;
        }
        
    }
`;

const Summary = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    width: 100%;
    
    > span {
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        color: var(--color-neutral-gray-800);
    }
    
    span.price {
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-20);
        line-height: var(--font-20);
        
        color: var(--color-blue-600);
    }
`;

const SummaryHeader = styled.h1`
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-24);
    line-height: var(--font-24);
    color: var(--color-neutral-gray-800);
    padding-left: 0rem;
    @media (max-width: 500px){
       
    }
`;

const Price = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  
  > .current {
    margin-bottom: var(--space-12);
    
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    line-height: var(--font-20);
    
    color: var(--color-blue-600);
  }
  
  > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 500;
  }

  @media (max-width: 500px){
      align-items: baseline;
      flex-direction: row;
      justify-content: space-between;
      .current{
        font-size: var(--font-16);
      }
      .strikethrough{
          font-size: var(--font-14);
      }
      
  }
`;

const PaymentPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: var(--space-48);
    
    > .payment {
        display: flex;
        flex-direction: column;
    }
    
    > .note {
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--font-14);
    
        margin-top: var(--space-32);
        margin-bottom: var(--space-16);
        
        color: var(--color-neutral-gray-500);
        
        align-self: center;
    }

 
`;

const Insurance = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    
    margin-bottom: 2.25rem;
    
    align-self: center;
    
    > input {
        margin-right: var(--space-16);
    }
    
    > label {
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        color: var(--color-neutral-gray-900);
    }

    @media (max-width: 500px){
        align-self: baseline;
    }
`;

const PaymentButton = styled.button`
    width: -webkit-fill-available;
    height: 2.25rem;
    position: relative;
    padding: var(--space-10);
    
    font-weight: 600;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: white;

    align-self: center;
    background: var(--color-orange-500);
    box-shadow: 0 4px 6px rgba(156, 66, 33, 0.12), 0 2px 4px rgba(237, 137, 54, 0.32);
    transition: background-color 0.3s ease-in;
    border-radius: var(--space-6);
    
    &:hover {
        background: var(--color-orange-400);
    }
    
    &:disabled {
        background: var(--color-gray-400);
        box-shadow: none;
    }

  
`;

const CartLayout = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-gap: 0;
    height: 12rem;
`;

const LineItemDetailsContainer = styled.div`
    margin-top: 1rem;
    display: grid;
    grid-auto-flow: row;
    
    grid-template-rows: auto 3rem 2.5rem;

    @media (max-width: 500px){
        margin-top: 0rem;
        display: block;
    }
`;

const PriceContainer = styled.div`
    margin-top: 1rem;
    display: grid;
    grid-auto-flow: row;
    
    grid-template-rows: auto 3rem 2.5rem;

    @media (max-width: 500px){
        padding-left: 1rem;
        margin-top: 0.25rem;
        grid-template-rows: auto;
        grid-gap: 1rem;
    }
`;

const Title = styled.div`
    width: 90%;
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-20);
    line-height: var(--font-28);
    
    color: var(--color-neutral-gray-900);

    @media (max-width: 500px){
        font-size: var(--font-16);
    }
`;

const Brand = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    
    color: var(--color-neutral-gray-900);

    @media (max-width: 500px){
        font-size: var(--font-16);
    }
`;

const AttributeSizeRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  > span {
    color: var(--color-gray-800);
    font-size: var(--font-16);
    line-height: var(--font-24);
    white-space: nowrap;
    font-weight: normal;
  }
  
  > .divider {
    width: 1px;
    height: var(--space-14);
    
    margin-left: var(--space-16);
    margin-right: var(--space-16);
    
    background: var(--color-gray-300);
  }

  @media (max-width: 500px){
      span{
        font-size: var(--font-12);
      }
      
  }
`;

const Remove = styled.button`
    padding: 0;
    justify-content: left;
    /* width: 0; */
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--font-16);
    color: red;

    @media (max-width: 500px){
        font-size: var(--font-12);
    }
`;

const Stock = styled.span`
    display: flex;
    justify-content: flex-end;
    white-space: nowrap;
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: var(--color-green-600);

    @media (max-width: 500px){
        font-size: var(--font-14);
    }
`;

const QuantityStepperContainer = styled.div`
    display: flex;
    flex-direction: row;
    
    justify-content: space-between;
    align-items: center;
    
    width: 8.5rem;
    height: 2.5rem;
    
    background: var(--color-gray-100);
    
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
    
    > input {
      width: 50%;
      height: -webkit-fill-available;
      padding: var(--space-6);
      border-radius: var(--space-6) 0 0 var(--space-6);
    }
    
    > button {
      width: 50%;
      height: -webkit-fill-available;
      color: white;
      background: var(--color-orange-500);
      border-radius: 0 var(--space-6) var(--space-6) 0;
    }
`;

const Quantity = styled.select`
    padding: var(--space-6);
    //padding: var(--space-10) var(--space-28);
    width: 8.5rem;
    height: 2.5rem;
    
    /* default/gray/100 */
    background: var(--color-gray-100);
    
    -webkit-appearance:none;
    background-image: url(/icons/chevron.svg);
    background-repeat: no-repeat;
    background-position-x: 7rem;
    background-position-y:center;
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  
  margin-top: var(--space-28);
  margin-bottom: var(--space-28);

  background: var(--color-gray-400);
`;

const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: var(--space-40);

  @media (max-width: 800px){
    margin-right: 0rem;
  }

  @media (max-width: 500px){
    
    margin-right: 0rem;
  }
`;

const LineItemContainer = styled.div`
    display: flex;
    flex-direction: column;

`;

const SubtotalContainer = styled.div`
    display: flex;
    flex-direction: row;
    
    align-items: center;
    
    align-self: flex-end;
    
    margin-top: var(--space-56);
    margin-bottom: var(--space-28);
    
    > .title {
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
    
        margin-right: var(--space-8);
        color: var(--color-neutral-gray-900);
    }
    
    > .price {
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-16);
        line-height: var(--font-16);
    
        color: var(--color-blue-600);
    }

    @media (max-width: 500px){
        display:none;
    }
`;

const ConfirmationContainer = styled.div`
    position: relative;
    width: -webkit-fill-available;
`;

function ShoppingCart({auth, setCustomerCart, userCart}) {
    const [hasInsurance, setHasInsurance] = useState(false);
    const [confirm, setConfirm] = useState('none');
    const [product, setProduct] = useState(null);
    const searchText = userCart[0]?.variant.product.category.name;
    const {
        paymentDialogRef,
        isComponentVisible,
        setIsComponentVisible,
    } = useComponentVisible(false);
    const [cart, setCart] = useState([]);
    const [summary, setSummary] = useState({
        originalPrice: 0,
        saleDeduction: 0,
        subTotal: 0,
        estTax: 0,
        orderTotal: 0
    });
    const [customQuantityIndex, setCustomQuantityIndex] = useState(-1);
    const [lineItemQuantities, setLineItemQuantities] = useState({});
    const [instantUpdateQuantities, setInstantUpdateQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        window.scrollTo(0, 0);
        handleResize();

    });
    const handleResize = () => {
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };

    useEffect(() => retrieveCustomerCart(), []);

    useEffect(() => {
        let quantities = {};
        cart.forEach((lineItem, index) => quantities[index] = lineItem.quantity);

        setLineItemQuantities(quantities);
    }, [cart]);

    // useEffect(() => handleCartUpdate(instantUpdateQuantities), []);
    
    useEffect(() => {
        const retrieveProduct = async () => {
            // setLoading(true);
            getCatalogue(searchText, '', '', 1, 10)
                .then(result => {
                    setProduct([...result.data]);

                })
                .catch(error => console.error(error))
        };
        retrieveProduct();
    }, []);

    const retrieveCustomerCart = () => {
        getCustomerCart(auth.customer_id, auth.token)
            .then(result => {
                setSummary({
                    originalPrice: result.totalOriginalPrice,
                    saleDeduction: result.totalSaleDeduction,
                    subTotal: result.totalSubTotal,
                    estTax: result.totalTax,
                    orderTotal: result.cartTotal,
                });
                setCart([...result.variants]);
            })
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    };

    const handleCartCheckout = () => {
        checkoutCart(auth.customer_id, auth.token, {has_insurance: hasInsurance})
            .then(result => {
                setSummary({
                    originalPrice: result.totalOriginalPrice,
                    saleDeduction: result.totalSaleDeduction,
                    subTotal: result.totalSubTotal,
                    estTax: result.totalTax,
                    orderTotal: result.cartTotal,
                });
                setCart([...result.variants]);
                setCustomQuantityIndex(-1);

                setCustomerCart({});

                // retrieveCustomerCart();
                history.push(`/order-confirmation/${result._id}`);
            })
            .catch(error => console.error(error));
    };

    const handleCartUpdate = (quantities, deleteIndex) => {
        let variants = [];
        let _quantities = quantities || lineItemQuantities;
        Object.keys(_quantities)
            .forEach((quantity, index) => {
                variants.push({
                    quantity: Number(_quantities[index]),
                    variant: cart[index].variant._id
                });
            });

        if (deleteIndex > -1) variants.splice(deleteIndex, 1);
        if( deleteIndex === 0) variants.shift()

        console.log('Delete Result: ', variants);
        updateCart(auth.customer_id, auth.token, {variants})
            .then(result => {
                setSummary({
                    originalPrice: result.totalOriginalPrice,
                    saleDeduction: result.totalSaleDeduction,
                    subTotal: result.totalSubTotal,
                    estTax: result.totalTax,
                    orderTotal: result.cartTotal,
                });
                setCart([...result.variants]);
                setCustomQuantityIndex(-1);
                
                setCustomerCart(result);
            })
            .catch(error => console.error(error));
    };

    const retrieveMedia = variant => {
        if (!variant.media) return null;

        let src = null;
        if (variant.media && variant.media.length) {
            for (let i = 0; i < variant.media.length; i++) {
                if (variant.media[i].type === 'image') {
                    src = getResourceFile(variant.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (variant.product.media && variant.product.media.length) {
                for (let i = 0; i < variant.product.media.length; i++) {
                    if (variant.product.media[i].type === 'image') {
                        src = getResourceFile(variant.product.media[i].resource);
                        break;
                    }
                }
            }
        }

        return src;
    };

    return (
        <>
            {loading ?
                <LoadingComponent/>
                :
                <Layout>
                    <h1 className="title">Your Shopping Cart</h1>
                    {
                        (cart.length > 0) && <div className="mobile-subtotal">
                            <span className="title">Subtotal ({cart.reduce((acc, val) => acc + val.quantity, 0)} items):</span>
                            <span className="price">{formatPrice(summary.subTotal)}</span>
                        </div>
                    }
                    <div/>
                    <SubLayout>
                    <LineItemsContainer>
                        {
                            cart.map((lineItem, index) => {
                                return <>
                                    {(lineItem.variant && lineItem.variant.product) ? <LineItemContainer key={`ShoppingCartLineItem_${index}`}>
                                        <CartLayout>
                                            <ImageContainer>
                                                {console.log('Cart: ', lineItemQuantities)}
                                                <div className="image-container"><img src={retrieveMedia(lineItem.variant)}/></div>
                                                {
                                                    (customQuantityIndex === index || lineItem.quantity > 9) ? <QuantityStepperContainer>
                                                            <input type="number" value={lineItemQuantities[index]} onChange={e => setLineItemQuantities({
                                                                ...lineItemQuantities,
                                                                [index]: Number(e.target.value)
                                                            })}/>
                                                            <button onClick={() => handleCartUpdate()}>Update</button>
                                                        </QuantityStepperContainer>
                                                        :
                                                        <Quantity value={lineItemQuantities[index]} onChange={e => {
                                                            const {value} = e.target;

                                                            if (value === 'more') {
                                                                setCustomQuantityIndex(index);
                                                            } else {
                                                              
                                                                setLineItemQuantities({
                                                                    ...lineItemQuantities,
                                                                    [index]: Number(e.target.value)
                                                                });
                                                                setInstantUpdateQuantities({
                                                                    ...lineItemQuantities,
                                                                    [index]: Number(e.target.value)
                                                                });
                                                            }
                                                        }}>
                                                            <option value="1">Qty: 1</option>
                                                            <option value="2">Qty: 2</option>
                                                            <option value="3">Qty: 3</option>
                                                            <option value="4">Qty: 4</option>
                                                            <option value="5">Qty: 5</option>
                                                            <option value="6">Qty: 6</option>
                                                            <option value="7">Qty: 7</option>
                                                            <option value="8">Qty: 8</option>
                                                            <option value="9">Qty: 9</option>
                                                            <option value="more">Qty: 10+</option>
                                                        </Quantity>
                                                }
                                            </ImageContainer>
                                            <LineItemDetailsContainer>
                                                <Title>
                                                    <Brand>{lineItem.variant.product.brand.name}</Brand>{` ${lineItem.variant.product.name}`}{`${lineItem.variant.description ? `, ${lineItem.variant.description}` : ''}`.trim()}
                                                </Title>
                                                <AttributeSizeRow>
                                                    {(lineItem.variant.product.attribute_name && lineItem.variant.attribute) &&
                                                    <span>{lineItem.variant.product.attribute_name}: {lineItem.variant.attribute}</span>}
                                                    {(lineItem.variant.product.attribute_name && lineItem.variant.attribute && lineItem.variant.product.size_name && lineItem.variant.size) &&
                                                    <div className="divider"/>}
                                                    {(lineItem.variant.product.size_name && lineItem.variant.size) &&
                                                    <span>{lineItem.variant.product.size_name}: {lineItem.variant.size}</span>}
                                                    {canvasWidth < 500 ?
                                                        <PriceContainer>
                                                            <Stock>In Stock</Stock>
                                                            <Remove onClick={() => handleCartUpdate(null, index)}>Remove</Remove>
                                                        </PriceContainer>
                                                        :
                                                        null
                                                    }
                                                </AttributeSizeRow>
                                                {canvasWidth < 500 ?
                                                    <Price>
                                                        <span className="current">{formatPrice(lineItem.subTotal)}</span>
                                                        {lineItem.saleDeduction !== 0 && <span className="strikethrough"><s>{formatPrice(lineItem.originalPrice)}</s></span>}
                                                    </Price>
                                                    :
                                                    null
                                                }
                                                {canvasWidth > 500 ?
                                                    <Remove onClick={() => handleCartUpdate(null, index)}>Remove</Remove>
                                                    :
                                                    null
                                                }
                                            </LineItemDetailsContainer>
                                            {canvasWidth > 500 ?
                                                <PriceContainer>
                                                    <Price>
                                                        <span className="current">{formatPrice(lineItem.subTotal)}</span>
                                                        {lineItem.saleDeduction !== 0 && <span className="strikethrough"><s>{formatPrice(lineItem.originalPrice)}</s></span>}
                                                    </Price>
                                                    <Stock>In Stock</Stock>
                                                    <div/>
                                                </PriceContainer>
                                                :
                                                null
                                            }
                                        </CartLayout>
                                        {(cart.length - 1 !== index) && <Divider/>}
                                        {
                                            (cart.length > 0 && cart.length - 1 === index) && <SubtotalContainer>
                                                <span className="title">Subtotal ({cart.reduce((acc, val) => acc + val.quantity, 0)} items):</span>
                                                <span className="price">{formatPrice(summary.subTotal)}</span>
                                            </SubtotalContainer>
                                        }
                                    </LineItemContainer> : null}
                                </>;
                            })
                        }
                    </LineItemsContainer>

                    <OrderDetailsContainer>
                        <SummaryContainer>
                            <Summary><SummaryHeader className="order">Order Summary</SummaryHeader></Summary>
                            <Summary><span>Original Price:</span><span>{formatPrice(summary.originalPrice)}</span></Summary>
                            <Summary><span>Sale Deduction:</span><span>-{formatPrice(summary.saleDeduction)}</span></Summary>
                            <Summary><span>Subtotal ({cart.reduce((acc, val) => acc + val.quantity, 0)} items):</span><span>{formatPrice(summary.subTotal)}</span></Summary>
                            <Summary><span>Est. Tax:</span><span>{formatPrice(summary.estTax)}</span></Summary>
                            <Summary>
                                <span className="price">Order Total:</span>
                                <span className="price">{formatPrice(summary.orderTotal)}</span>
                            </Summary>
                            <div className="divider"></div>
                        </SummaryContainer>
                        <PaymentPanelContainer>
                            <div className="payment">
                                <Insurance>
                                    <CustomCheckbox type="checkbox" name="insurance_cb" id="insurance_cb" checked={hasInsurance}
                                                    onChange={() => setHasInsurance(!hasInsurance)}/>

                                    {/* <input type="checkbox" name="insurance_cb" id="insurance_cb" checked={hasInsurance} onChange={() => setHasInsurance(!hasInsurance)}/> */}
                                    <label
                                        htmlFor="insurance_cb">Yes, I have Health Insurance</label>
                                </Insurance>

                                {/* TODO: For clicking outside confirmation component to close; clash happening with state-based display values (refix) */}
                                {/*<div ref={paymentDialogRef}>*/}
                                {/*    {showConfirmation &&*/}
                                {/*    <ConfirmationComponent className="confirm" setConfirm={enableConfirmation} hasInsurance={hasInsurance} price={summary.orderTotal}/>}*/}
                                {/*</div>*/}
                                {/*<PaymentButton*/}
                                {/*    disabled={cart.length === 0}*/}
                                {/*    onClick={() => enableConfirmation(true)}*/}
                                {/*>*/}
                                {/*    Place Order*/}
                                {/*</PaymentButton>*/}

                                <ConfirmationContainer>
                                    <PaymentButton disabled={cart.length === 0} onClick={() => {
                                        if (confirm === 'flex') setConfirm('none');
                                        else setConfirm('flex');

                                        // setIsComponentVisible(!isComponentVisible);
                                    }}>Place Order</PaymentButton>
                                    {
                                        confirm &&
                                        <ConfirmationComponent
                                            className={'confirm'}
                                            confirm={confirm}
                                            setConfirm={setConfirm}
                                            hasInsurance={hasInsurance}
                                            price={Number(summary.orderTotal.toFixed(2))}/>
                                    }
                                </ConfirmationContainer>
                            </div>
                            <div className="note">Accepted payment options</div>
                            <img src="/products/payments.svg"/>
                            <div style={{
                                width: '10rem',
                                alignSelf: 'center',
                                background: 'white',
                                padding: 'var(--space-8)',
                                marginTop: 'var(--space-16)',
                                borderRadius: 'var(--space-8)'
                            }}>
                                {/* <img src="/products/powered_by_fac.jpg" style={{
                                    width: 'inherit',
                                }}/> */}
                            </div>
                          
                        </PaymentPanelContainer>
                    <Disclaimer>Lorem ipsum dolor sit amet, consectetur adip iscing elit. 
                                Dignissim magna lorem ornare orac. At sed parturient rhoncus massa, commodo. Mattis eleifend mollis quam nulla.</Disclaimer>
                    </OrderDetailsContainer>
                    </SubLayout>
                    <Divider/>
                    <BackgroundGradient/>
                    <BottomContainer>

                        <h1>Similar to Items in your cart</h1>
                        <SimilarItemsContainer>
                        <div className="items">
                            {product?.map((value, index) => {
                                return (
                                    <ProductItem product={value} />
                                    
                                )
                            })}
                        </div>
                        </SimilarItemsContainer>
                    </BottomContainer>
                    <WaveOne/>
                    <WaveTwo/>
                </Layout>
            }
        </>
    );
}

const BottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: -30%;

    @media only screen and (max-width: 1500px){
        justify-content: center;
        margin-left: 0;
    }

    
    h1{
        padding-top: 2rem;
        padding-left: 2rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-20);
        background-color: white;
        padding-bottom: 32px;
        display: flex;
        align-items: center;


        color: var(--color-neutral-gray-900);
    }
    @media (max-width: 500px){
        h1{
            font-size: var(--font-16);
            font-weight: 400;
        }
      
    }

`;

const WaveOne = styled.div`

    background-image: url('/page-decor/product-top-swirl.png');
    background-repeat: no-repeat;
    background-position-x: left;
    background-position-y: top;
    position: absolute;
    width: 70vw;
    height: 57vh;
    bottom: 70%;
    left: 20%;
    z-index: -1;
    @media only screen and (max-width: 1024px){
        display: none;
    }
`;

const WaveTwo = styled.div`
    background-image: url('/page-decor/product-bottom-swirl.png');
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
    position: absolute;
    width: 49vw;
    height: 22vh;
    bottom: 50%;
    left: 50%;
    z-index: -1;
    @media only screen and (max-width: 1024px){
        display: none;
    }
`;

const Disclaimer = styled.div`
    width: 20rem;
    display: flex;
    align-self: center;
    /* padding-top: 1rem; */
    font-family: Inter,sans-serif;
    font-size: var(--font-14);
    line-height: var(--space-18);

`;

const SubLayout = styled.div`
    display: flex;
    flex-wrap: wrap;

    @media only screen and (max-width: 1100px){
        justify-content: center;
        width: 90vw;
    }

    @media only screen and (max-width: 800px){
        width: 90vw;
        justify-content: center;
    }
`;

const BackgroundGradient = styled.div`
        width: 100vw;
        height: 68vh;
        position: absolute;
        background: var(--color-neutral-gray-100);
        bottom: -85%;
        left: -1%;

        @media only screen and (max-width: 1440px){
            bottom: -97%;
        }
        @media only screen and (max-width: 1024px){
            bottom: -136%;
            height: 75vh;
        }
`;

const SimilarItemsContainer = styled.div`
    position: relative;
    width: 100vw;
    height: auto;
    overflow: scroll;

    .items{
        padding: 2rem;
        padding-left: 4rem;
        display: flex;
        /* grid-auto-flow: column; */
        gap: 1rem;
        flex-wrap: wrap;
        justify-content: center;
        width: max-content;
        /* background: var(--color-neutral-gray-100); */
    }

    
    ::-webkit-scrollbar {
        width: 1px;               /* width of the entire scrollbar */
    }

    ::-webkit-scrollbar-track {
        background: transparent;        /* color of the tracking area */
    }

    ::-webkit-scrollbar-thumb {
        background-color: transparent;    /* color of the scroll thumb */
        border-radius: 1px;       /* roundness of the scroll thumb */
        border: 1px solid var(--color-neutral-gray-100);  /* creates padding around scroll thumb */
    }

`;

const mapStateToProps = state => ({
    auth: state.auth,
    userCart: state.cart
});
const mapDispatchToProps = {
    setCustomerCart: setCart
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
